import React from "react";

function AboutUs() {
  return (
    <div className="container  mt-28 md:mt-40 lg:mt-64 flex flex-cols-2  bg-lime-700 max-w-full">
      <div className="container ml-24">
        <img w-26 h-full mt-0 ml-0 src="images/about.png" alt="about" />
      </div>
      <div className="lg:mt-8 container place-self-center w-full lg:full h-full  lg:h-full">
        <h1 className="text-3xl lg:text-7xl font-bold text-blue-900 mb-6">About Us</h1>
        <p className="m-8 text-xs lg:text-xl">
          Make your business shine online with a custom food website designed
          just for you by a professional designer. Need ideas? We’ve collected
          some amazing examples of food websites from our global community of
          designers. Get inspired and start planning the perfect food web design
          today.
        </p>
        <button className="bg-red-500 rounded-full mt-8 mb-8 border-2 px-6 py-2 border-rose-500 ">
          Read More
        </button>
      </div>
    </div>
  );
}

export default AboutUs;
